export const paymentProcessConfig = {
    "welcome-screen": {
        "name": "welcome-screen",
        "comments": [
            "Instructions"
        ],
        "controls": [
        ],
        "endProcess": true
    },
    "disconnect-screen": {
        "name": "disconnect-screen",
        "comments": [
            "Instructions"
        ],
        "controls": [
        ]
    },
    "purchase-welcome-screen": {
        "name": "purchase-welcome-screen",
        "comments": [
            "Pre request validation"
        ],
        "controls": [
            {
                "name": "ctrl-notfound-terminal",
                "title": "Terminal Not Found",
                "type": {
                    "category": 1, // validation type
                    "value": 2
                },
                "comments": [
                ],
                "style": "btn btn-danger control--btn",
                "action": {
                    "method": null,
                    "nextScreen": "welcome-screen"
                }
            },
            {
                "name": "ctrl-inactive-merchant",
                "title": "Inactive Merchant",
                "type": {
                    "category": 1, // validation type
                    "value": 3
                },
                "comments": [
                ],
                "style": "btn btn-danger control--btn",
                "action": {
                    "method": null,
                    "nextScreen": "welcome-screen"
                }
            },
            {
                "name": "ctrl-invalid-terminal",
                "title": "Invalid Terminal",
                "type": {
                    "category": 1, // validation type
                    "value": 21
                },
                "comments": [
                ],
                "style": "btn btn-danger control--btn",
                "action": {
                    "method": null,
                    "nextScreen": "welcome-screen"
                }
            },
            {
                "name": "ctrl-invalid-merchant",
                "title": "Invalid Merchant",
                "type": {
                    "category": 1, // validation type
                    "value": 20
                },
                "comments": [
                ],
                "style": "btn btn-danger control--btn",
                "action": {
                    "method": null,
                    "nextScreen": "welcome-screen"
                }
            }
        ],
        "start": {
            "name": "ctrl-validated",
            "title": "Manual Start",
            "type": {
                "category": 1, // validation type
                "value": 1 // CHANGE LOGIC DEPENDENCY clickControl FUNC and CHANGE LOGIC DEPENDENCY notifyBackendWithResult FUNC
            },
            "comments": [
            ],
            "style": "btn btn-secondary control--btn",
            "action": {
                "method": {
                    "name": "purchase-start",
                    "payload": null
                },
                "nextScreen": "tap-to-pay"
            }
        }
    },
    "refund-welcome-screen": {
        "name": "refund-welcome-screen",
        "comments": [
            "Pre request validation"
        ],
        "controls": [
            {
                "name": "ctrl-notfound-terminal",
                "title": "Terminal Not Found",
                "type": {
                    "category": 1, // validation type
                    "value": 2
                },
                "comments": [
                ],
                "style": "btn btn-danger control--btn",
                "action": {
                    "method": null,
                    "nextScreen": "welcome-screen"
                }
            },
            {
                "name": "ctrl-inactive-merchant",
                "title": "Inactive Merchant",
                "type": {
                    "category": 1, // validation type
                    "value": 3
                },
                "comments": [
                ],
                "style": "btn btn-danger control--btn",
                "action": {
                    "method": null,
                    "nextScreen": "welcome-screen"
                }
            },
            {
                "name": "ctrl-invalid-terminal",
                "title": "Invalid Terminal",
                "type": {
                    "category": 1, // validation type
                    "value": 21
                },
                "comments": [
                ],
                "style": "btn btn-danger control--btn",
                "action": {
                    "method": null,
                    "nextScreen": "welcome-screen"
                }
            },
            {
                "name": "ctrl-invalid-merchant",
                "title": "Invalid Merchant",
                "type": {
                    "category": 1, // validation type
                    "value": 20
                },
                "comments": [
                ],
                "style": "btn btn-danger control--btn",
                "action": {
                    "method": null,
                    "nextScreen": "welcome-screen"
                }
            }
        ],
        "start": {
            "name": "ctrl-validated",
            "title": "Manual Start",
            "type": {
                "category": 1, // validation type
                "value": 1 // CHANGE LOGIC DEPENDENCY clickControl FUNC and CHANGE LOGIC DEPENDENCY notifyBackendWithResult FUNC
            },
            "comments": [
            ],
            "style": "btn btn-secondary control--btn",
            "action": {
                "method": {
                    "name": "refund-start",
                    "payload": null
                },
                "nextScreen": "tap-to-pay"
            }
        }
    },
    "reversal-welcome-screen": {
        "name": "reversal-welcome-screen",
        "comments": [
            "Pre request validation"
        ],
        "controls": [
        ],
        "start": {
            "name": "ctrl-start",
            "title": "Manual Start",
            "type": {
                "category": 1, // validation type
                "value": 1 // CHANGE LOGIC DEPENDENCY clickControl FUNC and CHANGE LOGIC DEPENDENCY notifyBackendWithResult FUNC
            },
            "comments": [
            ],
            "style": "btn btn-secondary control--btn",
            "action": {
                "method": {
                    "name": "reversal-start",
                    "payload": null
                },
                "nextScreen": "reversal-processing"
            }
        }
    },
    "tap-to-pay": {
        "name": "tap-to-pay",
        "controls": [
            {
                "name": "ctrl-insert-card",
                "title": "Insert Card",
                "style": "btn btn-secondary control--btn",
                "action": {
                    "method": null,
                    "nextScreen": "enter-pin"
                },
                "paymentMethod": "Card"
            },
            {
                "name": "ctrl-tap-card",
                "title": "Tap Card",
                "style": "btn btn-secondary control--btn",
                "action": {
                    "method": {
                        "name": "func-card-tap",
                        "payload": null
                    },
                    "nextScreen": "enter-pin"
                },
                "paymentMethod": "Card"
            },
            {
                "name": "ctrl-tap-swipe",
                "title": "Swipe Card",
                "style": "btn btn-secondary control--btn",
                "action": {
                    "method": {
                        "name": "func-card-tap",
                        "payload": null
                    },
                    "nextScreen": "enter-pin"
                },
                "paymentMethod": "Card"
            },
            {
                "name": "ctrl-invalid-card",
                "title": "Invalid Card",
                "style": "btn btn-warning control--btn",
                "type": {
                    "category": 2, // update transaction result with status
                    "value": 6
                },
                "action": {
                    "method": null,
                    "nextScreen": "declined"
                }
            },
            {
                "name": "ctrl-abort-payment",
                "title": "Abort Payment",
                "style": "btn btn-danger control--btn",
                "type": {
                    "category": 2, // update transaction result with status
                    "value": 7
                },
                "action": {
                    "method": null,
                    "nextScreen": "aborted"
                }
            }
        ]
    },
    "enter-pin": {
        "name": "enter-pin",
        "controls": [
            {
                "name": "ctrl-pin-1234",
                "title": "Valid PIN",
                "style": "btn btn-secondary control--btn",
                "action": {
                    "method": {
                        "name": "func-confirm-pin",
                        "payload": {
                            "value": "1234"
                        }
                    },
                    "nextScreen": "confirm-pin"
                }
            },
            {
                "name": "ctrl-pin-1234",
                "title": "Wrong PIN",
                "style": "btn btn-secondary control--btn",
                "type": {
                    "category": 2, // update transaction result with status
                    "value": 8
                },
                "action": {
                    "method": {
                        "name": "func-confirm-pin",
                        "payload": {
                            "value": "4321"
                        }
                    },
                    "nextScreen": "declined"
                }
            }
        ]
    },
    "confirm-pin": {
        "name": "confirm-pin",
        "controls": [
            {
                "name": "ctrl-confirm",
                "title": "Press green(Confirm)",
                "style": "btn btn-primary control--btn",
                "action": {
                    "method": null,
                    "nextScreen": "processing"
                }
            }
        ]
    },
    "processing": {
        "name": "processing",
        "controls": [
            {
                "name": "ctrl-approved",
                "title": "Approve transaction",
                "style": "btn btn-primary control--btn",
                "type": {
                    "category": 2, // update transaction result with status
                    "value": 1
                },
                "action": {
                    "method": null,
                    "nextScreen": "approved"
                }
            },
            {
                "name": "ctrl-declined",
                "title": "Decline transaction",
                "style": "btn btn-danger control--btn",
                "type": {
                    "category": 2, // update transaction result with status
                    "value": 9
                },
                "action": {
                    "method": null,
                    "nextScreen": "declined"
                }
            },
            {
                "name": "ctrl-lost-connection",
                "title": "Simulate lost connection",
                "style": "btn btn-danger control--btn",
                "type": {
                    "category": 2, // update transaction result with status
                    "value": 10
                },
                "action": {
                    "method": {
                        "name": "func-connection-lost",
                        "payload": null
                    },
                    "nextScreen": "connection-lost"
                }
            },
            {
                "name": "ctrl-customer-cancellation",
                "title": "Customer cancellation",
                "style": "btn btn-danger control--btn",
                "type": {
                    "category": 2, // update transaction result with status
                    "value": 11
                },
                "action": {
                    "method": null,
                    "nextScreen": "declined"
                }
            },
            {
                "name": "ctrl-abort-payment",
                "title": "Abort Payment",
                "style": "btn btn-danger control--btn",
                "type": {
                    "category": 2, // update transaction result with status
                    "value": 7
                },
                "action": {
                    "method": null,
                    "nextScreen": "aborted"
                }
            }
        ]
    },
    "reversal-processing": {
        "name": "reversal-processing",
        "controls": [
            {
                "name": "ctrl-reversed",
                "title": "Approve Reversal",
                "style": "btn btn-primary control--btn",
                "type": {
                    "category": 2, // update transaction result with status
                    "value": 1
                },
                "action": {
                    "method": null,
                    "nextScreen": "approved"
                }
            },
            {
                "name": "ctrl-declined",
                "title": "Decline Reversal",
                "style": "btn btn-danger control--btn",
                "type": {
                    "category": 2, // update transaction result with status
                    "value": 9
                },
                "action": {
                    "method": null,
                    "nextScreen": "declined"
                }
            },
        ]
    },
    "approved": {
        "name": "approved",
        "controls": [
        ],
        "timeOut": {
            "interval": 2000,
            "nextScreen": "online-api-approved"
        }
    },
    "cancel-approved": {
        "name": "approved",
        "controls": [
        ],
        "timeOut": {
            "interval": 2000,
            "nextScreen": "online-api-approved"
        }
    },
    "declined": {
        "name": "declined",
        "controls": [
        ],
        "timeOut": {
            "interval": 2000,
            "nextScreen": "online-api-declined"
        }
    },
    "aborted": {
        "name": "aborted",
        "controls": [
        ],
        "timeOut": {
            "interval": 2000,
            "nextScreen": "online-api-cancelled"
        }
    },
    "apm-pay": {
        "name": "apm-pay",
        "controls": [
            {
                "name": "ctrl-taponswish",
                "title": "Tap on screen",
                "style": "btn btn-secondary control--btn",
                "action": {
                    "method": null,
                    "nextScreen": "apm-qrscan"
                }
            }
        ]
    },
    "apm-qrscan": {
        "name": "apm-qrscan",
        "controls": [
            {
                "name": "ctrl-swishqrapprove",
                "title": "Scan & Approve Transaction",
                "style": "btn btn-primary control--btn",
                "type": {
                    "category": 2, // update transaction result with status
                    "value": 1
                },
                "action": {
                    "method": null,
                    "nextScreen": "apm-approve"
                }
            },
            {
                "name": "ctrl-swishqrfailed",
                "title": "Scan & Failed Transaction",
                "style": "btn btn-danger control--btn",
                "type": {
                    "category": 2, // update transaction result with status
                    "value": 9
                },
                "action": {
                    "method": null,
                    "nextScreen": "apm-failed"
                }
            },
            {
                "name": "ctrl-swishqrabort",
                "title": "Abort Transaction",
                "style": "btn btn-warning control--btn",
                "action": {
                    "method": null,
                    "nextScreen": "aborted"
                }
            }
        ]
    },
    "apm-approve": {
        "name": "apm-approve",
        "controls": [
        ],
        "timeOut": {
            "interval": 2000,
            "nextScreen": "online-api-approved"
        }
    },
    "apm-failed": {
        "name": "apm-failed",
        "controls": [
        ],
        "timeOut": {
            "interval": 2000,
            "nextScreen": "online-api-declined"
        }
    },
    "connection-lost": {
        "name": "connection-lost",
        "controls": [
            {
                "name": "ctrl-connection-lost",
                "title": "Auto Retry & Connection Test",
                "style": "btn btn-primary control--btn",
                "action": {
                    "method": {
                        "name": "func-auto-reconnect",
                        "payload": null
                    },
                    "nextScreen": "welcome-screen"
                }
            }
        ]
    },
    "unlink-terminal": {
        "name": "unlink-terminal",
        "controls": [

        ]
    },
    "online-api-approved": {
        "name": "online-api-approved",
        "controls": [
        ],
        "timeOut": {
            "interval": 2000,
            "nextScreen": "welcome-screen"
        }
    },
    "online-api-cancelled": {
        "name": "online-api-cancelled",
        "controls": [
        ],
        "timeOut": {
            "interval": 2000,
            "nextScreen": "welcome-screen"
        }
    },
    "online-api-declined": {
        "name": "online-api-declined",
        "controls": [
        ],
        "timeOut": {
            "interval": 2000,
            "nextScreen": "welcome-screen"
        }
    },
}